var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineMade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_778_805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_778_805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.525 9L17.425 6.6L15.025 5.5L17.425 4.4L18.525 2L19.625 4.4L22.025 5.5L19.625 6.6L18.525 9ZM20.525 16L19.725 14.3L18.025 13.5L19.725 12.7L20.525 11L21.325 12.7L23.025 13.5L21.325 14.3L20.525 16ZM7.52495 22L7.22495 19.65C7.09162 19.6 6.96262 19.5333 6.83795 19.45C6.71262 19.3667 6.60828 19.2833 6.52495 19.2L4.32495 20.15L1.82495 15.8L3.72495 14.4C3.72495 14.2667 3.72495 14.1333 3.72495 14C3.72495 13.8667 3.72495 13.7333 3.72495 13.6L1.82495 12.2L4.32495 7.85L6.52495 8.8C6.60828 8.71667 6.71262 8.63333 6.83795 8.55C6.96262 8.46667 7.09162 8.4 7.22495 8.35L7.52495 6H12.525L12.825 8.35C12.9583 8.4 13.0876 8.46667 13.213 8.55C13.3376 8.63333 13.4416 8.71667 13.525 8.8L15.725 7.85L18.225 12.2L16.325 13.6C16.325 13.7333 16.325 13.8667 16.325 14C16.325 14.1333 16.325 14.2667 16.325 14.4L18.225 15.8L15.725 20.15L13.525 19.2C13.4416 19.2833 13.3376 19.3667 13.213 19.45C13.0876 19.5333 12.9583 19.6 12.825 19.65L12.525 22H7.52495ZM10.025 17C10.8583 17 11.5666 16.7083 12.15 16.125C12.7333 15.5417 13.025 14.8333 13.025 14C13.025 13.1667 12.7333 12.4583 12.15 11.875C11.5666 11.2917 10.8583 11 10.025 11C9.19162 11 8.48328 11.2917 7.89995 11.875C7.31662 12.4583 7.02495 13.1667 7.02495 14C7.02495 14.8333 7.31662 15.5417 7.89995 16.125C8.48328 16.7083 9.19162 17 10.025 17Z",
    fill: "#2C846A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineMade);
export default __webpack_public_path__ + "static/media/machine-made.b9c5adaf4f8a1f0da69359647865c621.svg";
export { ForwardRef as ReactComponent };